import * as React from 'react';
import { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { UpdateSPOCStatus  } from '../Helper/API';
import { BackdropLoader } from '../../DoctorMangement/BackdropLoader'
import { ToastEmitter } from '../../DoctorMangement/ToastEmitter'
import UserFeaturesContext  from '../../../hook/UserDetails/UserFeaturesContext';
import { getFeaturesForUser } from "../Helper/utils"
import { jsonParser } from '../../../helper/jsonParser';
import { ToggleSwitch } from "../../DoctorMangement/ToggleSwitch"
import { checkFeatureFeasbility } from '../../../helper/utils';
import { FEATURE_NAME } from '../../DoctorMangement/constant';
import { logEventToAnalyticsPlatform } from '../../../helper/events';
import { EVENTS } from '../../DoctorMangement/events_Constant';

export const SPOCProfileButton = ({ userId, userName, profileStatus, fetchSPOCDetails, providerMasterEntityId, ...props }) => {
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const { userFeatures, saveUserFeatures } = useContext(UserFeaturesContext);
  const isButtonEnabled = checkFeatureFeasbility(FEATURE_NAME.SPOC_STATUS_UPDATE,userFeatures)

  const changeProfileStatus = async () => {
    try{
      let data = {
        active: checked ? false : true,
        providerMasterEntityId: providerMasterEntityId,
        entityId:localStorage.getItem('user_details') ? JSON.parse(localStorage.getItem('user_details')).entityId : null,
        providerMasterEntityId: providerMasterEntityId,
        userName: userName,
        userId: userId,
        modifiedBy: localStorage.getItem('user_details') ? JSON.parse(localStorage.getItem('user_details')).userId : null,
      }
      setIsLoading(true);
      const resp = await UpdateSPOCStatus(data);
      setIsLoading(false);
      if (resp?.isSuccess) {
        ToastEmitter('Profile Status Updated Successfully', 'success');
        logEventToAnalyticsPlatform({
          name: EVENTS.PC_LS_ACTION.name,
          payload:{
            tab_name:EVENTS.TAB_NAME_LC_SCREEN,
            filterValue: checked ? 'false' : 'true',
            reference_id:""+userId,
            reference_provider_id:"" + providerMasterEntityId,
            service_name:EVENTS.SERVICE_NAME_SPOC,
            action:EVENTS.ACTION.SPOC_PROFILE_STATUS
          },
          schema: EVENTS.PC_LS_ACTION.schema,
        })
        await fetchSPOCDetails();
      }
    }
    catch(err){
      setIsLoading(false);
      ToastEmitter('Something went wrong Please Try Again', 'error');
    } 
  }

  const toggleProfileStatus = async () => {
    await changeProfileStatus()
    if (userName == jsonParser(localStorage.getItem('user_details')).userName) {
      setIsLoading(true);
      const {userFeature, userRoles} = await getFeaturesForUser(history)
      saveUserFeatures(userFeature, userRoles);
    }
    setIsLoading(false);
  }
  
 useEffect(() => {
  if(profileStatus!= undefined &&  profileStatus != null){
    setChecked(profileStatus)
  }
 },[profileStatus])

  return (
    <>
      {isLoading && <BackdropLoader isLoading={isLoading} />}
      <div className='flex flex-row gap-2'>
        {isButtonEnabled &&<ToggleSwitch
          checked={checked}
          onChange={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleProfileStatus();
          }}
          rounded
          disable={isButtonEnabled}
        />}
        <p className="text-sm text-normal flex justify-center py-1">{checked ? "Active" : "Deactive"}</p>
      </div>
    </>
  );
};